export default class APIOrganization {
  constructor(API) {
    this.api = API;
  }
  async deleteOrganizationByID(orgID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/tenant/org/' + orgID;
    return await req.exec();
  }
  //reporting
  async organizationLicensesReportPreview(searchTerm, from, sortOrder, sortField) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/tenant/report/orglicenses/preview';
    req.body = { searchTerm, from, sortOrder, sortField };
    return await req.exec();
  }
  async organizationLicensesReportFile(searchTerm, sortOrder, sortField) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/tenant/report/orglicenses';
    req.bodyType = 'JSON/BLOB';
    req.body = { searchTerm, sortOrder, sortField };
    return await req.exec();
  }
}
